import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// Chrome fires this once, early; keep it at module level so the button can use it later.
let deferredPrompt = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
  });
}

const isInstalled = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

const Steps = () => (
  <ul className="space-y-3 text-sm text-white/80">
    <li><span className="text-[#D4AF37]">Chrome (Android):</span> toque nos três pontinhos ⋮ no topo e escolha "Instalar app" ou "Adicionar à tela inicial".</li>
    <li><span className="text-[#D4AF37]">Samsung Internet:</span> toque em ≡ e escolha "Adicionar página a" → "Tela inicial".</li>
    <li><span className="text-[#D4AF37]">iPhone (Safari):</span> toque em Compartilhar e escolha "Adicionar à Tela de Início".</li>
    <li><span className="text-[#D4AF37]">Aberto pelo WhatsApp ou Instagram?</span> Toque em ⋮ e escolha "Abrir no Chrome" antes de instalar.</li>
  </ul>
);

export const InstallAppButton = () => {
  const [hidden, setHidden] = useState(isInstalled());
  const [help, setHelp] = useState(false);

  useEffect(() => {
    const done = () => setHidden(true);
    window.addEventListener("appinstalled", done);
    return () => window.removeEventListener("appinstalled", done);
  }, []);

  if (hidden) return null;

  const install = async () => {
    if (!deferredPrompt) return setHelp(true);
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    deferredPrompt = null;
    if (outcome === "accepted") setHidden(true);
  };

  return (
    <>
      <button data-testid="install-app-btn" onClick={install} className="btn-secondary-outline text-xs justify-center">
        <Download size={14} strokeWidth={1.5} />
        Instalar o App
      </button>
      <Dialog open={help} onOpenChange={setHelp}>
        <DialogContent data-testid="install-app-help" className="bg-[#0A0A0A] border-[#D4AF37]/40 text-white rounded-none max-w-sm">
          <DialogHeader>
            <DialogTitle className="font-heading text-2xl font-light">Instalar o app EZ Capelli</DialogTitle>
          </DialogHeader>
          <Steps />
        </DialogContent>
      </Dialog>
    </>
  );
};
